import React from 'react';

import ExpandIcon from '@material-ui/icons/ExpandMore';

import Button from '../Button';
import { IconWrapper, InnerWrapper, Wrapper } from './styles';
import { Heading } from '../Typography/Heading';
import { Paragraph } from '../Typography/Paragraph';

export interface Props {
  title: string;
  titleRight?: string;
  description?: string;
  handleButtonClicks?: any;
  height?: string;
  isOpen?: boolean;
  toggleClick?: () => void;
  zeroPadding?: boolean;
  marginBottom?: string;
  buttons?: { text: string; width?: string; disabled: boolean; handleClick: () => void }[];
}

const Titlebar: React.FC<Props> = ({
  title = 'Group',
  titleRight,
  description,
  buttons,
  height = '48px',
  isOpen,
  toggleClick,
  zeroPadding = false,
  marginBottom,
}) => {
  return (
    <Wrapper className="titlebar" zeroPadding={zeroPadding} marginBottom={marginBottom}>
      <InnerWrapper hasIcon={isOpen !== undefined} minHeight={height}>
        {isOpen !== undefined && (
          <IconWrapper isOpen={isOpen} onClick={toggleClick}>
            <ExpandIcon />
          </IconWrapper>
        )}
        <Heading level={5} bottom={description ? 4 : 0} color="var(--colorWhite)">
          {title}
        </Heading>
        {description && (
          <Paragraph level={5} color="var(--colorWhite)" bottom={0}>
            {description}
          </Paragraph>
        )}
      </InnerWrapper>
      {titleRight && (
        <Heading level={6} color="var(--colorWhite)" bottom={description ? 4 : 0}>
          {titleRight}
        </Heading>
      )}
      {buttons?.map(({ text, disabled, width, handleClick }, index) => (
        <Button
          key={index}
          text={text ?? 'New'}
          handleClick={handleClick}
          styleType="Transparent"
          height="32px"
          width={width ?? '72px'}
          disabled={disabled ?? false}
        />
      ))}
    </Wrapper>
  );
};

export default Titlebar;
